<template>
  <div class="col-12 _col-xl-8 d-flex">
    <div class="card flex-grow-1">
      <h6 class="card-header">Transports</h6>
      <div class="card-body position-relative">

        <BarHorizontalComponent
          bar-styles="height: 60px;"
          :data="datas"
          @click="itemOnClick"
        />
        <div class="small text-muted d-flex gap-3 flex-wrap">
          <div>Transport inclus: <b>{{ withTransport }}</b></div>
          <div>Sans Transport: <b>{{ withoutTransport }}</b></div>

          <div class="ms-auto">Total Inscrits: <b>{{ totalInscrits }}</b><small v-if="companions.length > 0"> (dont {{ companionOnlyCount }} accompagnants)</small></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import * as ChartHelper from '@/compositions/chartHelper';
  import { computed } from 'vue';
  import { useBoardFilters } from '@/compositions/useBoardFilters';

  // Ce widget ne s'intéresse qu'aux inscrits : il n'applique pas le filtre statut
  // (il filtre lui-même sur completionDate) mais applique le filtre organisateurs
  const { participations, companions, filters } = useBoardFilters({ applyStatus: false })

  const companionOnlyCount = computed(() => {
    return companions.value.length ?? 0;
  });

  const inscrits = computed(() => {
    return participations.value.filter(x=>x.invitation?.completionDate != null && x.invitation?.refusalDate == null) ?? [];
  });

  const totalInscrits = computed(() => {
    return (inscrits.value.length ?? 0) + (companions.value.length ?? 0);
  });

  const withTransport = computed(() => {
    const tempParticipants =  inscrits.value.filter(x=>x.travelInfo?.withPackage == true && x.travelInfo?.specialCase != true && x.travelInfo?.withoutTransport != true) ?? [];
    const tempCompanions = filters?.value.hideCompanions ? [] : tempParticipants.flatMap(x => x.companions ?? []) ?? [];
    return tempParticipants.length + tempCompanions.length;
  });

  const withoutTransport = computed(() => {
    const tempParticipants =  inscrits.value.filter(x=>x.travelInfo?.withPackage == false || x.travelInfo?.withoutTransport == true) ?? [];
    const tempCompanions = filters?.value.hideCompanions ? [] : tempParticipants.flatMap(x => x.companions ?? []) ?? [];
    return tempParticipants.length + tempCompanions.length;
  });

  const datas = computed(() => {
    return {
      labels: ["Participants"],
      datasets: [
        {
          label: "Transport inclus",
          data: [withTransport.value],
          backgroundColor: [ChartHelper.Colors[0]],
          borderColor: [ChartHelper.Borders[0]],
        },
        {
          label: "Sans Transport",
          data: [withoutTransport.value],
          backgroundColor: [ChartHelper.Colors[1]],
          borderColor: [ChartHelper.Borders[1]],
        }
      ]
    }
  });

  const itemOnClick = (label: string | undefined, value: number | [number, number] | undefined | null, index: number) => {
    if(filters) {
      switch(index) {
        case 0:
          filters.value.transportFilter = 'with';
          break;
        case 1:
          filters.value.transportFilter = 'without';
          break;
      }
    }
  };
</script>
